// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sal?societaId&stato&commessaId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","sedeId":"number","commessaId":"number","ordineId":"number","numero":"string|null","stato":"BOZZA|EMESSO|APPROVATO_CLIENTE|APPROVATO_BACKOFFICE|FATTURATO","dataEmissione":"string","dataApprovazione":"string","tipoApprovazione":"CLIENTE|BACKOFFICE","importoTotale":"number","tipoDocumento":{"id":"number","codice":"string","nome":"string"},"createdAt":"string","ordine":{"id":"number","numero":"string","flussoCommerciale":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
